import { Component, Inject, AfterViewInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'gtw-import-paste-dialog',
    template: `
    <div class="modal-header">
      <h3 class="modal-title">
        {{ modalTitle }}
        <i (click)="close()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
        <i
          class="fa pull-right"
          [ngClass]="{'fa-plus-square-o': minimised, 'fa-minus-square-o': !minimised}"
          style="margin-right: 10px; cursor: pointer;"
          (click)="minimised = !minimised"></i>
      </h3>
    </div>

    @if (!minimised) {
<div class="modal-body" (click)="focusPasteArea()">
      Please hit <b style="font-size:26px">Ctrl+V</b> to paste data into
      <div>
        <textarea #pasteArea
                  class="gg-hidden-paste-area"
                  placeholder="Paste here"
                  [(ngModel)]="pasteData"
                  (paste)="onPaste($event)"></textarea>
      </div>
    </div>
}

    @if (!minimised) {
<div class="modal-footer"></div>
}
  `,
    styles: [`
    .modal-header {
      padding: 8px 12px;
      border-bottom: 1px solid #a9440f;
      background: #c65a1e;
    }
    .modal-title {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      line-height: 1.2;
    }
    .modal-title .fa {
      color: #fff;
      font-size: 16px;
      margin-top: 2px;
    }
    .modal-body {
      padding: 15px;
      background: #fff;
      color: #333;
      min-height: 70px;
    }
    .modal-footer {
      padding: 0;
      min-height: 10px;
      border-top: 0;
      background: #fff;
    }
    .gg-hidden-paste-area {
      width: 100%;
      min-height: 120px;
      padding: 8px;
      margin-top: 10px;
      border: 1px solid #ccc;
      resize: vertical;
    }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ImportPasteDialogComponent implements AfterViewInit {
  modalTitle = 'Existing Batch Transactions';
  minimised = false;
  pasteData = '';

  @ViewChild('pasteArea') pasteArea!: ElementRef<HTMLTextAreaElement>;

  constructor(
    private dialogRef: MatDialogRef<ImportPasteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data?.title) {
      this.modalTitle = data.title;
    }
  }

  ngAfterViewInit(): void {
    this.focusPasteArea();
  }

  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text/plain') || '';

    // Prefer the ClipboardEvent payload over ngModel. The paste event fires
    // before Angular has necessarily written the textarea value back into
    // `pasteData`, so closing the dialog from a timeout could race and return
    // an empty string. This mirrors the legacy path that reads clipboard text
    // directly and then passes it to processXls().
    if (pastedText) {
      event.preventDefault();
      this.pasteData = pastedText;
      this.dialogRef.close({ pastedData: pastedText });
      this.pasteData = '';
      return;
    }

    setTimeout(() => {
      const value = this.pasteArea?.nativeElement?.value || this.pasteData;
      this.dialogRef.close({ pastedData: value });
      this.pasteData = '';
    }, 1);
  }

  close(): void {
    this.dialogRef.close();
  }

  focusPasteArea(): void {
    setTimeout(() => {
      this.pasteArea?.nativeElement?.focus();
    }, 100);
  }
}
